import React, { Component } from "react";

export default class DataScienceImg extends Component {
  render() {
    const theme = this.props.theme;
    const primary = theme.imageHighlight || "#0E6BA8";
    const accent = theme.headerColor || "#0E6BA877";
    const surface = theme.body || "#ffffff";
    const ink = theme.text || "#001C55";

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80%"
        height="auto"
        viewBox="0 0 500 400"
        fill="none"
        aria-label="Web development and learning data science"
      >
        <ellipse cx="250" cy="370" rx="180" ry="14" fill={accent} opacity="0.4" />

        {/* Browser window */}
        <g transform="translate(60,80)">
          <rect width="240" height="180" rx="12" fill={ink} opacity="0.9" />
          {/* traffic lights */}
          <circle cx="18" cy="18" r="5" fill="#FF5F57" />
          <circle cx="34" cy="18" r="5" fill="#FEBC2E" />
          <circle cx="50" cy="18" r="5" fill="#28C840" />
          {/* URL bar */}
          <rect x="80" y="10" width="140" height="16" rx="8" fill={surface} opacity="0.18" />
          {/* viewport */}
          <rect x="10" y="36" width="220" height="134" rx="6" fill={surface} />
          {/* page title */}
          <rect x="22" y="50" width="120" height="10" rx="3" fill={primary} />
          <rect x="22" y="68" width="180" height="6" rx="3" fill={primary} opacity="0.45" />
          <rect x="22" y="80" width="160" height="6" rx="3" fill={primary} opacity="0.45" />
          {/* hero card */}
          <rect x="22" y="98" width="84" height="60" rx="6" fill={primary} opacity="0.85" />
          <rect x="116" y="98" width="40" height="28" rx="6" fill={primary} opacity="0.4" />
          <rect x="116" y="130" width="40" height="28" rx="6" fill={primary} opacity="0.6" />
          <rect x="166" y="98" width="40" height="60" rx="6" fill={primary} opacity="0.55" />
        </g>

        {/* React atom badge on browser */}
        <g transform="translate(280,118)">
          <circle r="22" fill={surface} stroke={primary} strokeWidth="2" />
          <ellipse rx="18" ry="6" fill="none" stroke={primary} strokeWidth="2" />
          <ellipse rx="18" ry="6" fill="none" stroke={primary} strokeWidth="2" transform="rotate(60)" />
          <ellipse rx="18" ry="6" fill="none" stroke={primary} strokeWidth="2" transform="rotate(120)" />
          <circle r="3.5" fill={primary} />
        </g>

        {/* Neural network */}
        <g transform="translate(330,210)">
          {/* layer 1 */}
          <circle cx="0" cy="-50" r="9" fill={primary} />
          <circle cx="0" cy="-20" r="9" fill={primary} />
          <circle cx="0" cy="10" r="9" fill={primary} />
          <circle cx="0" cy="40" r="9" fill={primary} />
          {/* layer 2 */}
          <circle cx="55" cy="-40" r="9" fill={primary} opacity="0.85" />
          <circle cx="55" cy="-10" r="9" fill={primary} opacity="0.85" />
          <circle cx="55" cy="20" r="9" fill={primary} opacity="0.85" />
          <circle cx="55" cy="50" r="9" fill={primary} opacity="0.85" />
          {/* layer 3 */}
          <circle cx="110" cy="-20" r="9" fill={primary} opacity="0.7" />
          <circle cx="110" cy="10" r="9" fill={primary} opacity="0.7" />

          {/* connections */}
          {[-50, -20, 10, 40].map((y1) =>
            [-40, -10, 20, 50].map((y2) => (
              <line
                key={`${y1}-${y2}`}
                x1="0"
                y1={y1}
                x2="55"
                y2={y2}
                stroke={primary}
                strokeWidth="0.7"
                opacity="0.35"
              />
            ))
          )}
          {[-40, -10, 20, 50].map((y1) =>
            [-20, 10].map((y2) => (
              <line
                key={`b-${y1}-${y2}`}
                x1="55"
                y1={y1}
                x2="110"
                y2={y2}
                stroke={primary}
                strokeWidth="0.7"
                opacity="0.45"
              />
            ))
          )}
        </g>

        {/* Studying badge */}
        <g transform="translate(60,290)">
          <rect width="160" height="32" rx="16" fill={primary} />
          <circle cx="20" cy="16" r="6" fill={surface} />
          <text x="92" y="21" textAnchor="middle" fontSize="11" fontFamily="Helvetica, sans-serif" fontWeight="700" fill={surface}>
            CURRENTLY LEARNING
          </text>
        </g>

        {/* code dot accents */}
        <g transform="translate(80,330)" fill={primary} opacity="0.6">
          <text fontSize="13" fontFamily="Menlo, monospace" fontWeight="700">{"<html /> { ai }"}</text>
        </g>
      </svg>
    );
  }
}
